// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__vFsIw","label":"LanguagePicker_label__fFYHo","icon":"LanguagePicker_icon__DdP0Z"};